import { render, staticRenderFns } from "./PrestationList.vue?vue&type=template&id=b72f82e2&scoped=true"
import script from "./PrestationList.vue?vue&type=script&lang=js"
export * from "./PrestationList.vue?vue&type=script&lang=js"
import style0 from "./PrestationList.vue?vue&type=style&index=0&id=b72f82e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f82e2",
  null
  
)

export default component.exports